import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Wedding, Weddings } from '../Weddings';
import type { INote } from './Notes.types';

@Identifiable
@Timestampable
@Untrackable
export class Note extends AbstractDocument<INote> {
  readonly collections = {};
}

export class Notes extends AbstractCollection<Note, INote> {
  static path = 'notes';

  constructor(document: Wedding) {
    super(document.collection(Notes.path), Note);
  }

  get wedding() {
    return Weddings._.getById(this.reference.parent!.id);
  }
}
